import * as React from 'react';

import gql from 'graphql-tag';

import { Typography, Typography2 } from '@coursera/cds-core';
import { Box, Row } from '@coursera/coursera-ui';

import withFragments from 'bundles/graphql/components/withFragments';

import _t from 'i18n!nls/reviews';

type Props = {
  story: any;
};

function LearnerStory({ story }: Props) {
  return (
    <Row rootClassName="rc-LearnerStory border-bottom">
      <Typography2 component="h3" className="m-y-3" variant="subtitleMedium">
        {_t('Learner Story')}
      </Typography2>
      <Typography className="m-b-2" variant="h2" component="h4">
        {story.comment}
      </Typography>
      <Box rootClassName="m-b-2">
        <Typography2 variant="bodyPrimary" component="strong">
          {story.author}
        </Typography2>
        <p className="border-right p-x-1 text-secondary">{story.job}</p>
        <p className="p-x-1 text-secondary">{story.credential}</p>
      </Box>
    </Row>
  );
}
const ReviewTestimonials = gql`
  fragment LearnerStoryFragment on XdpV1_org_coursera_xdp_nostos_NostosXDPReviewTestimonial {
    comment
    job
    author
    credential
  }
`;
export default withFragments({
  testimonials: ReviewTestimonials,
})(LearnerStory);
